import { render, staticRenderFns } from "./AssociarEmail.vue?vue&type=template&id=d0a38bb4"
import script from "./AssociarEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssociarEmail.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports